import * as React from 'react';
import { connect } from 'react-redux';

import { ButtonRadioGroupField } from '@cian/components';

import { IAppState, Dispatch } from '../../../../common/state';
import { EWindowsType } from '../../../../json_query';
import { changeWindowsType } from '../../../state/advanced/windows';
import { InlineParam, Row } from '../markup';

interface IWindowsProps {
  windows: EWindowsType;
  onChanged(value: EWindowsType): void;
}

const getChangedWindowsType = (value: string): EWindowsType => {
  if (value === 'Courtyard') {
    return EWindowsType.Courtyard;
  } else if (value === 'Street') {
    return EWindowsType.Street;
  } else {
    return EWindowsType.Any;
  }
};

const windows: React.StatelessComponent<IWindowsProps> = props => {
  let radioGroupValue = '';
  if (props.windows === EWindowsType.Courtyard) {
    radioGroupValue = 'Courtyard';
  }
  if (props.windows === EWindowsType.Street) {
    radioGroupValue = 'Street';
  }

  return (
    <Row title="Окна">
      <InlineParam>
        <ButtonRadioGroupField
          uncheckable
          value={radioGroupValue}
          onValueChange={value => props.onChanged(getChangedWindowsType(value))}
          values={[
            { value: 'Courtyard', label: 'Во двор' },
            { value: 'Street', label: 'На улицу' },
          ]}
        />
      </InlineParam>
    </Row>
  );
};

// tslint:disable-next-line:no-default-export
export default connect(
  (state: IAppState) => ({
    windows: state.filters.jsonQuery.windows_type ? state.filters.jsonQuery.windows_type.value : EWindowsType.Any,
  }),
  (dispatch: Dispatch) => ({
    onChanged: (value: EWindowsType) => {
      dispatch(changeWindowsType(value));
    },
  }),
)(windows);
